<template>
    <div class="pick-new-h5">
        <!-- 音频资源 -->
        <audio id="pickSuccessAudio" src="../../../images/拣货成功.mp3" preload="auto"></audio>
        <audio id="errorAudio" src="../../../images/出错了.mp3" preload="auto"></audio>
        <audio id="nextPickAudio" src="../../../images/下一个商品.mp3" preload="auto"></audio>

        <!-- 错误提示区 -->
        <div v-if="errorMessage" class="error-message">
            {{ errorMessage }}
        </div>

        <!-- 批次号信息 -->
        <div class="batch-info">
            <div class="batch-number">
                <span class="batch-label">批次号:</span>
                <span class="batch-value">{{ batchNumber }}</span>
            </div>
        </div>

        <div class="search-row">
            <span class="search-label">查询编码:</span>
            <input type="text"
                   ref="searchInput"
                   v-model="searchCode"
                   placeholder="请输入产品编码"
                   class="search-input"
                   @focus="handleInputFocus"
                   @keyup.enter.prevent="handleSearchCode" />
        </div>
        <div class="search-row">
            <span class="search-label">拣货编码:</span>
            <input type="text"
                   ref="pickInput"
                   v-model="pickCode"
                   placeholder="请扫描产品编码"
                   class="search-input"
                   @focus="handleInputFocus"
                   @keyup.enter.prevent="handlePickCode" />
        </div>

        <!-- 拣货详情列表 -->
        <div class="pick-list">
            <div v-for="item in pickDetailList" :key="item.id" class="pick-item">
                <!-- 上半部分：图片和基本信息 -->
                <div class="item-top">
                    <div class="item-left">
                        <img :src="getImageUrl(item.productImgGuid)" class="product-img" />
                    </div>
                    <div class="item-info">
                        <div class="info-row">
                            <span class="info-label">货架号:</span>
                            <span class="info-value">{{ item.shelfPosition || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">产品编码:</span>
                            <span class="info-value">{{ item.productNo || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">SKU:</span>
                            <span class="info-value">{{ item.productSku || '-' }}</span>
                        </div>
                        <div class="info-row">
                            <span class="info-label">产品内码:</span>
                            <span class="info-value">{{ item.id || '-' }}</span>
                        </div>
                    </div>
                </div>

                <!-- 下半部分：数量、分箱、手动操作 -->
                <div class="item-bottom">
                    <!-- 应拣/已拣数量 -->
                    <div class="count-row">
                        <div class="count-item">
                            <span class="count-label">应拣:</span>
                            <span class="count-value">{{ item.count }}</span>
                        </div>
                        <div class="count-item">
                            <span class="count-label">已拣:</span>
                            <span class="count-value" :class="{ 'complete': Number(item.pickCount) >= Number(item.count) }">
                                {{ item.pickCount }}
                            </span>
                        </div>
                    </div>

                    <!-- 分箱显示区域 -->
                    <div v-if="hasBoxList(item)" class="box-list-area">
                        <div class="box-items">
                            <span v-for="(value, key) in item.boxList" :key="key"
                                  class="box-tag"
                                  :class="{ 'box-complete': getBoxPickedCount(item, key) >= getBoxTotalCount(item, key) }">
                                [{{ key }}]{{ getBoxPickedCount(item, key) }}/{{ getBoxTotalCount(item, key) }}
                            </span>
                        </div>
                        <!-- 当前需要拣货的箱子展示 -->
                        <div v-if="currentBoxNumber(item)" class="current-box">
                            <div class="big-box-number">{{ currentBoxNumber(item) }}#</div>
                            <div class="box-hint">请将商品放入 {{ currentBoxNumber(item) }} 号箱</div>
                        </div>
                    </div>

                    <!-- 手动数量输入和完成按钮（仅当未完成时显示） -->
                    <div v-if="Number(item.pickCount) < Number(item.count)" class="manual-action">
                        <div class="manual-row">
                            <span class="manual-label">手动数量:</span>
                            <input type="number"
                                   v-model.number="manualCounts[item.id]"
                                   class="manual-input"
                                   :min="1"
                                   :max="getRemainingCount(item)"
                                   :placeholder="'最大' + getRemainingCount(item)" />
                            <button @click.prevent="handleManualPick(item)" class="manual-pick-btn">完成拣货</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 下一个商品按钮 - 放在列表底部 -->
            <div v-if="showNextButton" class="next-button-bottom">
                <button class="next-pick-btn" @click.prevent="handleNextPick">拣取下一个商品</button>
            </div>

            <!-- 空状态 -->
            <div v-if="pickDetailList.length === 0" class="empty-state">
                暂无拣货数据
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'BackStockPickNewH5',
        data() {
            return {
                batchId: null,
                batchNumber: '',
                searchCode: '',
                pickCode: '',
                pickDetailList: [],
                errorMessage: '',
                manualCounts: {},
                showNextButton: false
            };
        },
        mounted() {
            this.batchId = this.$route.query.id;
            this.batchNumber = this.$route.query.batchNumber || '';

            if (this.batchId) {
                this.loadPickDetail('').then(() => {
                    this.focusPickInput();
                });
            } else {
                this.setErrorMessage('缺少批次ID');
                this.focusPickInput();
            }
        },
        methods: {
            ...mapActions('backStockOrderBatch', ['getPickDetaiList', 'addPickCount']),

            setErrorMessage(msg) {
                this.errorMessage = msg;
            },

            handleInputFocus(e) {
                const input = e.target;
                // 设置 readonly 阻止键盘弹出
                input.readOnly = true;
                // 延迟移除 readonly，让扫描枪可以输入
                setTimeout(() => {
                    input.readOnly = false;
                }, 200);
            },

            clearErrorMessage() {
                this.errorMessage = '';
            },
            handleSearchInputClick() {
                this.$refs.searchInput.focus();
            },
            handlePickInputClick() {
                this.$refs.pickInput.focus();
            },
            playAudio(audioId) {
                try {
                    const audio = document.getElementById(audioId);
                    if (audio) {
                        audio.currentTime = 0;
                        audio.play().catch(e => console.error('音频播放失败:', e));
                    }
                } catch (error) {
                    console.error('播放音频出错:', error);
                }
            },

            focusPickInput() {
                this.$nextTick(() => {
                    if (this.$refs.pickInput) {
                        this.$refs.pickInput.focus();
                    }
                });
            },

            focusSearchInput() {
                this.$nextTick(() => {
                    if (this.$refs.searchInput) {
                        this.$refs.searchInput.focus();
                    }
                });
            },

            async loadPickDetail(code) {
                this.clearErrorMessage();

                const result = await this.getPickDetaiList({
                    batchId: this.batchId,
                    code: code || ''
                });

                if (result && typeof result === 'object' && !Array.isArray(result)) {
                    this.pickDetailList = [result];
                } else if (Array.isArray(result)) {
                    this.pickDetailList = result;
                } else {
                    this.pickDetailList = [];
                }

                this.pickDetailList.forEach(item => {
                    if (this.hasBoxList(item)) {
                        const currentBoxRemaining = this.getCurrentBoxRemaining(item);
                        this.$set(this.manualCounts, item.id, currentBoxRemaining > 0 ? currentBoxRemaining : 1);
                    } else {
                        const remaining = Number(item.count) - Number(item.pickCount);
                        this.$set(this.manualCounts, item.id, remaining > 0 ? remaining : 0);
                    }
                });
            },

            async handleSearchCode() {
                this.clearErrorMessage();

                if (!this.searchCode.trim()) {
                    await this.loadPickDetail('');
                    this.searchCode = '';
                    this.focusPickInput();
                    return;
                }
                await this.loadPickDetail(this.searchCode.trim());
                this.searchCode = '';
                this.focusPickInput();
            },

            async handlePickCode() {
                this.clearErrorMessage();

                const code = this.pickCode.trim();
     
                if (!code) {
                    this.setErrorMessage('请输入拣货编码');
                    this.pickCode = '';
                    this.focusPickInput();
                    return;
                }

                const matchedItem = this.pickDetailList.find(item => item.productNo === code);

                if (!matchedItem) {
                    this.setErrorMessage(`输入编码 ${code} 不正确`);
                    this.playAudio('errorAudio');
                    this.pickCode = '';
                    this.focusPickInput();
                    return;
                }

                const pickCount = Number(matchedItem.pickCount);
                const count = Number(matchedItem.count);

                if (pickCount >= count) {
                    this.setErrorMessage('该商品已拣货完成，不允许拣货');
                    this.playAudio('errorAudio');
                    this.pickCode = '';
                    this.focusPickInput();
                    return;
                }

                await this.addPickQuantity(matchedItem, 1);
            },

            async addPickQuantity(item, count) {
                this.clearErrorMessage();

                if (count <= 0) {
                    this.setErrorMessage('拣货数量必须大于0');
                    this.playAudio('errorAudio');
                    this.focusPickInput();
                    return;
                }

                const remaining = this.getRemainingCount(item);
                if (count > remaining) {
                    this.setErrorMessage(`拣货数量不能超过剩余数量${remaining}`);
                    this.playAudio('errorAudio');
                    this.focusPickInput();
                    return;
                }

                const result = await this.addPickCount({
                    id: item.id,
                    count: count
                });

                if (result) {
                    this.playAudio('pickSuccessAudio');

                    // 更新本地数据
                    item.pickCount = Number(item.pickCount) + count;

                    // 更新手动数量
                    if (this.hasBoxList(item)) {
                        const currentBoxRemaining = this.getCurrentBoxRemaining(item);
                        this.$set(this.manualCounts, item.id, currentBoxRemaining > 0 ? currentBoxRemaining : 1);
                    } else {
                        const newRemaining = Number(item.count) - Number(item.pickCount);
                        this.$set(this.manualCounts, item.id, newRemaining > 0 ? newRemaining : 0);
                    }

                    this.pickCode = '';

                    // 检查当前商品是否已完成
                    if (this.getRemainingCount(item) === 0) {
                        this.playAudio('nextPickAudio');
                        this.showNextButton = true;
                    } else {
                        this.focusPickInput();
                    }
                } else {
                    this.setErrorMessage('拣货失败');
                    this.playAudio('errorAudio');
                    this.focusPickInput();
                }
            },

            handleManualPick(item) {
                this.clearErrorMessage();

                const manualCount = this.manualCounts[item.id];
                if (!manualCount || manualCount <= 0) {
                    this.setErrorMessage('请输入有效的拣货数量');
                    this.playAudio('errorAudio');
                    this.focusPickInput();
                    return;
                }
                const remaining = this.getRemainingCount(item);
                if (manualCount > remaining) {
                    this.setErrorMessage(`拣货数量不能超过剩余数量${remaining}`);
                    this.playAudio('errorAudio');
                    this.focusPickInput();
                    return;
                }

                this.$Modal.confirm({
                    title: '确认手动拣货',
                    content: `确认手动拣货数量 ${manualCount} 吗？`,
                    onOk: async () => {
                        await this.addPickQuantity(item, manualCount);
                    }
                });
            },

            getBoxTotalCount(item, boxNo) {
                return Number(item.boxList[boxNo]) || 0;
            },

            getBoxPickedCount(item, boxNo) {
                if (!this.hasBoxList(item)) return 0;

                const boxKeys = Object.keys(item.boxList).sort((a, b) => Number(a) - Number(b));
                const totalPicked = Number(item.pickCount);
                let accumulatedPicked = 0;

                for (const box of boxKeys) {
                    const boxTotal = Number(item.boxList[box]) || 0;
                    if (box === boxNo) {
                        const picked = Math.min(boxTotal, totalPicked - accumulatedPicked);
                        return Math.max(0, picked);
                    }
                    accumulatedPicked += boxTotal;
                }
                return 0;
            },

            currentBoxNumber(item) {
                if (!this.hasBoxList(item)) return null;

                const boxKeys = Object.keys(item.boxList).sort((a, b) => Number(a) - Number(b));
                let accumulatedPicked = 0;
                const totalPicked = Number(item.pickCount);

                for (const boxNo of boxKeys) {
                    const boxTotal = Number(item.boxList[boxNo]) || 0;
                    const boxPicked = Math.min(boxTotal, totalPicked - accumulatedPicked);

                    if (boxPicked < boxTotal) {
                        return boxNo;
                    }
                    accumulatedPicked += boxTotal;
                }
                return null;
            },

            getCurrentBoxRemaining(item) {
                const currentBox = this.currentBoxNumber(item);
                if (!currentBox) return 0;

                const boxTotal = this.getBoxTotalCount(item, currentBox);
                const boxPicked = this.getBoxPickedCount(item, currentBox);
                return boxTotal - boxPicked;
            },

            getRemainingCount(item) {
                return Number(item.count) - Number(item.pickCount);
            },

            hasBoxList(item) {
                return item.boxList && Object.keys(item.boxList).length > 0;
            },

            handleNextPick() {
                this.clearErrorMessage();
                this.showNextButton = false;
                this.loadPickDetail(this.searchCode.trim()).then(() => {
                    this.pickCode = '';
                    this.focusPickInput();
                });
            },

            getImageUrl(guid) {
                if (!guid) {
                    return 'https://via.placeholder.com/70x70?text=No+Image';
                }
                if (guid.startsWith('http')) {
                    return guid;
                }
                return `/api/files/download?guid=${guid}`;
            }
        }
    };
</script>

<style scoped>
    .pick-new-h5 {
        min-height: 100vh;
        background-color: #f5f5f5;
        padding: 8px;
        max-width: 320px;
        margin: 0 auto;
        position: relative;
    }

    .error-message {
        background-color: #ffebee;
        color: #f44336;
        padding: 8px 12px;
        border-radius: 4px;
        font-size: 12px;
        margin-bottom: 8px;
        word-break: break-word;
        line-height: 1.4;
        max-height: 48px;
        overflow-y: auto;
    }

    .batch-info {
        background: white;
        border-radius: 6px;
        padding: 10px 12px;
        margin-bottom: 8px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    }

    .batch-number {
        display: flex;
        align-items: center;
        font-size: 14px;
    }

    .batch-label {
        width: 65px;
        color: #666;
    }

    .batch-value {
        color: #007aff;
        font-weight: 500;
        word-break: break-all;
    }

    .search-area {
        background: white;
        border-radius: 6px;
        padding: 8px;
        margin-bottom: 8px;
    }

    .search-row {
        display: flex;
        align-items: center;
        margin-bottom: 8px;
    }

        .search-row:last-child {
            margin-bottom: 0;
        }

    .search-label {
        width: 70px;
        font-size: 13px;
        color: #666;
    }

    .search-input {
        flex: 1;
        height: 36px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 10px;
        font-size: 13px;
    }

        .search-input:focus {
            border-color: #007aff;
            outline: none;
        }

    .pick-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .pick-item {
        background: white;
        border-radius: 6px;
        padding: 12px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .item-top {
        display: flex;
        gap: 10px;
    }

    .item-left {
        width: 70px;
        flex-shrink: 0;
    }

    .product-img {
        width: 70px;
        height: 70px;
        object-fit: cover;
        border-radius: 4px;
        background-color: #f0f0f0;
    }

    .item-info {
        flex: 1;
    }

    .info-row {
        display: flex;
        font-size: 12px;
        line-height: 1.5;
        margin-bottom: 4px;
    }

        .info-row:last-child {
            margin-bottom: 0;
        }

    .info-label {
        width: 65px;
        color: #666;
        flex-shrink: 0;
    }

    .info-value {
        color: #333;
        font-weight: 500;
        flex: 1;
        word-break: break-all;
    }

    .item-bottom {
        border-top: 1px solid #f0f0f0;
        padding-top: 10px;
    }

    .count-row {
        display: flex;
        gap: 16px;
        margin-bottom: 8px;
        background-color: #f8f8f8;
        padding: 6px 8px;
        border-radius: 4px;
    }

    .count-item {
        display: flex;
        align-items: baseline;
    }

    .count-label {
        font-size: 12px;
        color: #666;
        margin-right: 4px;
    }

    .count-value {
        font-size: 14px;
        font-weight: 500;
        color: #333;
    }

        .count-value.complete {
            color: #4caf50;
            font-weight: bold;
        }

    .box-list-area {
        margin: 8px 0;
    }

    .box-items {
        display: flex;
        flex-wrap: wrap;
        gap: 6px;
        margin-bottom: 8px;
    }

    .box-tag {
        background-color: #e9ecef;
        padding: 2px 8px;
        border-radius: 12px;
        font-size: 11px;
        color: #495057;
    }

        .box-tag.box-complete {
            background-color: #c8e6c9;
            color: #2e7d32;
        }

    .current-box {
        text-align: center;
        margin: 8px 0;
    }

    .big-box-number {
        font-size: 32px;
        font-weight: bold;
        color: #ff9800;
        line-height: 1;
    }

    .box-hint {
        font-size: 12px;
        color: #666;
        margin-top: 4px;
    }

    .manual-action {
        margin-top: 8px;
    }

    .manual-row {
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: nowrap;
    }

    .manual-label {
        font-size: 11px;
        color: #666;
        width: 55px;
        flex-shrink: 0;
    }

    .manual-input {
        flex: 1;
        min-width: 0;
        width: 0;
        height: 32px;
        border: 1px solid #ddd;
        border-radius: 4px;
        padding: 0 6px;
        font-size: 12px;
    }

    .manual-pick-btn {
        flex-shrink: 0;
        padding: 0 10px;
        height: 32px;
        background-color: #007aff;
        color: white;
        border: none;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        cursor: pointer;
    }

        .manual-pick-btn:active {
            opacity: 0.8;
        }

    .empty-state {
        text-align: center;
        padding: 40px 0;
        color: #999;
        font-size: 14px;
    }

    /* 下一个商品按钮 - 底部样式 */
    .next-button-bottom {
        margin-top: 16px;
        margin-bottom: 8px;
        display: flex;
        justify-content: center;
    }

    .next-pick-btn {
        width: 100%;
        max-width: 280px;
        padding: 12px 24px;
        background-color: #4caf50;
        color: white;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: bold;
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

        .next-pick-btn:active {
            opacity: 0.9;
            transform: scale(0.98);
        }
</style>